import { AppointmentListData } from "@/models/club";
import { clockText, faNumber } from "./format";
import { calendarVisits, timeString } from "./upcoming";

export type InvoiceSuggestion = { appointmentId: number; customer: string; detail: string };

// A visit that ended earlier than this is no longer the one being paid for at the counter.
const ENDED_WITHIN_MINUTES = 120;

type Options = {
  now?: Date;
  // Stylists only get their own visits.
  merchantUserId?: number;
  withStaff?: boolean;
  limit?: number;
};

// Visits wrapping up without an invoice: in progress, or ended within the last two hours. The one whose
// scheduled end is closest to now comes first, so a visit finishing early still wins over an older one.
export function invoiceSuggestions(data: AppointmentListData | undefined, options: Options = {}): InvoiceSuggestion[] {
  const { now = new Date(), merchantUserId, withStaff = false, limit = 2 } = options;
  const distance = (end: Date) => Math.abs(end.getTime() - now.getTime());
  return calendarVisits(data, now)
    .visits.filter(({ appointment }) => appointment.id && !appointment.purchaseRegistered)
    .filter(({ appointment, user }) => merchantUserId === undefined || (appointment.merchantUserId ?? user?.id) === merchantUserId)
    .filter(({ start, end }) => start <= now && now.getTime() - end.getTime() <= ENDED_WITHIN_MINUTES * 60_000)
    .sort((a, b) => distance(a.end) - distance(b.end))
    .slice(0, limit)
    .map(({ appointment, user, end }) => {
      const customer = `${appointment.customerFirstName ?? ""} ${appointment.customerLastName ?? ""}`.trim();
      const staff = withStaff ? appointment.merchantUserFirstName?.trim() || user?.firstName?.trim() : "";
      const minutesAgo = Math.max(1, Math.round((now.getTime() - end.getTime()) / 60_000));
      const state = end > now ? "در حال انجام" : `${faNumber(minutesAgo)} دقیقه پیش تمام شد`;
      const visit = [`نوبت ${clockText(timeString(appointment.startTime))}`, staff && `با ${staff}`].filter(Boolean).join(" ");
      return { appointmentId: appointment.id as number, customer: customer || "مشتری بدون نام", detail: `${visit} · ${state}` };
    });
}
